import React, { PropsWithChildren } from 'react';
import { HiddenInput } from '../HiddenInput/HiddenInput';
import Btn, { BtnModifier } from '../../../../components/molecules/Btn';
import { Icons } from '../../../../components/atoms/SVG';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { SelectListItemBasic } from './SelectListItemBasic';

type SelectListItemHiddenInputProps = PropsWithChildren<{
  title: string;
  name: string;
  value: string;
  deleteButtonTitle: string;
  deleteElement(): void;
  ariaControls: string;
}>;

export function SelectListItemHiddenInput({
  title,
  name,
  value,
  deleteButtonTitle,
  deleteElement,
  ariaControls,
}: Readonly<SelectListItemHiddenInputProps>) {
  return (
    <SelectListItemBasic title={title}>
      <div className="select-list__interactions">
        <HiddenInput name={name} value={value} />
        <Btn
          modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
          ariaControls={ariaControls}
          svgSpriteId={Icons.DELETE_X_SMALL}
          type="button"
          text={deleteButtonTitle}
          titleText={deleteButtonTitle}
          hiddenText
          tooltipPlacement={TooltipPlacement.LEFT}
          onClick={deleteElement}
        />
      </div>
    </SelectListItemBasic>
  );
}
